const styles = () => ({
    root: {
        height: window.innerHeight,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
    },
    text: {
        fontSize: "30px",
        fontWeight: "400px",
    },
    error: {
        fontSize: "50px",
        color: "red",
        fontWeight: "700px",
    },
});

export default styles